/*
 * Created by Vladimir Shishlyannikov on 12/07/2023.
 *
 * Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 */

import moment from 'moment-timezone';

export const defaultDateFormat = 'MM/DD/YYYY HH:mm:ss';

export const getMomentInLosAngelesTimeZone = (value: Date | string, culture?: string) => {
  // TODO make format as an optional argument
  return culture ? moment.tz(value, 'America/Los_Angeles').locale(culture) : moment.tz(value, 'America/Los_Angeles');
};

export const getMomentWithTz = (value: Date | string, region: string, culture?: string) => {
  // TODO make format as an optional argument
  return culture ? moment.tz(value, getTz(region)).locale(culture) : moment.tz(value, getTz(region));
};

export const getTz = (region: string | null) => {
  if (!region || region === 'US') {
    return 'America/Los_Angeles';
  }

  return 'Europe/London';
};
